const CATEGORIES = {
  ACCESS: 'access',
  BACKEND: 'backend',
  REQUEST: 'request',
};

export default CATEGORIES;
